<template>
  <v-container fluid class="sor-item-visualisation">
    <v-row>
      <v-col cols="6">
        <Pie :chart-options="sectionChartOptions"
             :chart-data="sectionChartData"
             css-classes="section-chart-div"
             :height="400"></Pie>
      </v-col>
      <v-col cols="6">
        <Radar :chart-options="workNatureChartOptions"
               :chart-data="workNatureChartData"
               css-classes="work-nature-chart-div"
               :height="400"></Radar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <Doughnut :chart-options="subSectionChartOptions"
                  :chart-data="subSectionChartData"
                  css-classes="sub-section-chart-div"
                  :height="400"></Doughnut>
      </v-col>
      <v-col cols="6">
        <!--        <Doughnut :chart-options="proprietaryChartOptions"-->
        <!--                  :chart-data="proprietaryChartData"-->
        <!--                  :plugins="proprietaryChartPlugins"-->
        <!--                  css-classes="proprietary-chart-div"-->
        <!--                  :height="400"></Doughnut>-->
        <Bar :chart-options="specificallyOrderProprietaryChartOptions"
             :chart-data="specificallyOrderProprietaryChartData"
             css-classes="proprietary-chart-div"
             :height="400"></Bar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <Doughnut :chart-options="extraOverAddToChartOptions"
                  :chart-data="extraOverAddToChartData"
                  :plugins="extraOverAddToChartPlugins"
                  css-classes="proprietary-chart-div"
                  :height="400"></Doughnut>
        <!--          <Bar :chart-options="extraOverAddToChartOptions"-->
        <!--               :chart-data="extraOverAddToChartData"-->
        <!--               css-classes="extra-over-add-to-chart-div"-->
        <!--               :height="400"></Bar>-->
      </v-col>
      <v-col cols="4">
        <LineChart :chart-options="rateRangeChartOptions"
                   :chart-data="rateRangeChartData"
                   css-classes="rate-range-chart-div"
                   :height="400"></LineChart>
      </v-col>
      <v-col cols="4">
        <Bar :chart-options="unitChartOptions"
             :chart-data="unitChartData"
             css-classes="unit-chart-div"
             :height="400"></Bar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Bar, Doughnut, Line, Pie, Radar} from 'vue-chartjs/legacy'
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import palette from 'google-palette'
import {computed, ref} from "@vue/composition-api/dist/vue-composition-api";
import _ from "lodash";
import {WORK_NATURE} from "@/constants";

ChartJS.register(ChartDataLabels, ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, RadialLinearScale, LinearScale, PointElement, LineElement)
export default {
  name: 'SorItemVisualisation',
  components: {Pie, Doughnut, Radar, Bar, LineChart: Line},
  props: {
    visualiseResults: Object,
  },
  setup(props, {root}) {
    const percentageLabelPlugins = ref([
      {
        id: 'percentageLabel',
        afterDraw(chart, args, options) {
          const {ctx} = chart;
          ctx.save();

          ctx.font = "16px sans-serif";
          ctx.textAlign = "left";
          // ctx.fillStyle = "rgb(255, 134, 32)";
          ctx.fillStyle = "black";
          ctx.fillText('Percentage', 0, 388);
          //
        },
      }
    ])
    const numberLabelPlugins = ref([
      {
        id: 'numberLabel',
        afterDraw(chart, args, options) {
          const {ctx} = chart;
          ctx.save();

          ctx.font = "16px sans-serif";
          ctx.textAlign = "left";
          // ctx.fillStyle = "rgb(255, 134, 32)";
          ctx.fillStyle = "black";
          ctx.fillText('Number', 0, 388);
          //
        },
      }
    ])

    const sectionChartOptions = ref({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: 'Top 10 Sections (%)',
          align: 'start',
          padding: 10,
          color: "rgb(0,0,0)",
          font: {
            size: 20,
            weight: 'bold',
            family: 'Arial Black',
          }
        },
        datalabels: {
          color: 'white',
          font: {
            weight: 'bold',
          },
          formatter: (value) => {
            return value.toFixed(1) + "%";
          },
        },
        legend: {
          position: 'left',
          labels: {
            font: {
              size: 10,
            },
            usePointStyle: true,
          }
        },
      },
    });
    const sectionChartData = computed(() => {
      if (props.visualiseResults) {
        let sectionLabels = [];
        let sectionData = [];
        _.forEach(props.visualiseResults.results_by_section, (value, key) => {
          sectionLabels.push(key);
          sectionData.push(value / props.visualiseResults.item_count * 100);
        })
        let sorted = _.reverse(_.sortBy(_.zip(sectionLabels, sectionData), (a) => a[1]))
        let top10 = _.slice(sorted, 0, 10);
        let [top10Labels, top10Data] = _.unzip(top10);
        let others = _.slice(sorted, 5);
        return {
          labels: top10Labels,
          datasets: [{
            label: 'No. of Items',
            data: top10Data,
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  return `${ctx.label}: ${ctx.raw.toFixed(1)}%`;
                },
              }
            },
            backgroundColor: palette('mpn65', sectionData.length).map((hex) => `#${hex}`),
          }],
        }
      }

      return {
        labels: [''],
        datasets: [
          {
            label: '',
            data: [1],
          }
        ],
      }
    });

    const subSectionChartOptions = ref({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: 'Sub-Headings (no.)',
          align: 'start',
          padding: 10,
          color: "rgb(0,0,0)",
          font: {
            size: 20,
            weight: 'bold',
            family: 'Arial Black',
          }
        },
        datalabels: {
          color: 'white',
          font: {
            weight: 'bold',
          },
          formatter: (value) => value,
        },
        legend: {
          position: 'left',
          labels: {
            font: {
              size: 8,
            },
            usePointStyle: true,
          }
        },
      },
    })
    const subSectionChartData = computed(() => {
      if (props.visualiseResults) {
        let labels = [];
        let data = [];
        _.forEach(props.visualiseResults.results_by_sub_section, (value, key) => {
          labels.push(key.replaceAll('<br>', '').replace('  ', ' '));
          data.push(value);
        });
        let sorted = _.reverse(_.sortBy(_.zip(labels, data), (a) => a[1]))
        let top = _.slice(sorted, 0, 9);
        let [topLabels, topData] = _.unzip(top);
        let others = _.slice(sorted, 9);
        return {
          labels: topLabels,
          datasets: [{
            data: topData,
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  return `${ctx.raw}: ${ctx.label}`;
                },
              }
            },
            backgroundColor: palette('tol-rainbow', 10).map((hex) => `#${hex}`),
          }],
        }
      }

      return {
        labels: [''],
        datasets: [
          {
            label: '',
            data: [1],
          }
        ],
      }
    })

    const specificallyOrderProprietaryChartOptions = ref({
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: 'Proprietary/Approved item & Specifically Order Items (no.)',
          align: 'start',
          color: "rgb(0,0,0)",
          padding: 5,
          font: {
            size: 18,
            weight: 'bold',
            family: "Arial Black"
            //family: 'Arial-BoldMT',
          }
        },
        legend: {
          display: false,
        },
      },

      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: false,
          }
        }
      }
    })
    const specificallyOrderProprietaryChartData = computed(() => {
      if (props.visualiseResults) {
        return {
          labels: ['Proprietary / Approved Items', 'Specifically Order Items',],
          datasets: [{
            data: [
              props.visualiseResults.proprietary_count,
              props.visualiseResults.specifically_order_count,
            ],
            backgroundColor: [
              'rgba(152, 216, 56)',
              'rgba(43, 213, 216)',
            ],
            borderColor: [
              'rgba(152, 216, 56)',
              'rgba(43, 213, 216)',
            ],
            borderWidth: 1
          }],
        }
      }

      return {
        labels: ['Proprietary / Approved Items', 'Specifically Order Items',],
        datasets: [{
          data: [0, 0],
          backgroundColor: [
            'rgba(152, 216, 56)',
            'rgba(43, 213, 216)',
          ],
          borderColor: [
            'rgba(152, 216, 56)',
            'rgba(43, 213, 216)',
          ],
          borderWidth: 1
        }],
      }
    })

    const workNatureChartOptions = ref({
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: 'Work Nature (no.)',
          align: 'start',
          padding: 10,
          color: "rgb(0,0,0)",
          font: {
            size: 20,
            weight: 'bold',
            family: 'Arial Black',
          }
        },
        datalabels: {
          display: false,
        },
        legend: {
          display: false,
        },
      },
    });
    const workNatureChartData = computed(() => {
      if (props.visualiseResults) {
        const results = props.visualiseResults.results_by_work_nature;
        return {
          labels: [
            'FIX ONLY',
            'SUPPLY ONLY',
            'TD & CLEAR AWAY',
            'TD & SET ASIDE FOR REUSE',
            // 'EXTRA OVER',
            'SUPPLY & FIX & MISC.',
          ],
          datasets: [{
            data: [
              WORK_NATURE.FIX_ONLY,
              WORK_NATURE.SUPPLY_ONLY,
              WORK_NATURE.TD_AND_CLEAR_WAY,
              WORK_NATURE.TD_AND_SET_ASIDE_FOR_REUSE,
              // WORK_NATURE.EXTRA_OVER,
              WORK_NATURE.SUPPLY_AND_FIX_AND_MISC,
            ].map((k) => results[k] || 0),

            fill: true,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgb(255, 99, 132)',
            pointBackgroundColor: 'rgb(255, 99, 132)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255, 99, 132)'
          }],
        }
      }

      return {
        labels: [
          'FIX ONLY',
          'SUPPLY ONLY',
          'TD & CLEAR AWAY',
          'TD & SET ASIDE FOR REUSE',
          // 'EXTRA OVER',
          'SUPPLY & FIX & MISC.',
        ],
        datasets: [{
          data: [0, 0, 0, 0, 0],

          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgb(255, 99, 132)',
          pointBackgroundColor: 'rgb(255, 99, 132)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(255, 99, 132)'
        }],
      }
    })

    const extraOverAddToChartOptions = ref({
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: 'Extra Over/ Add to Items (%)',
          align: 'start',
          padding: 10,
          color: "rgb(0,0,0)",
          font: {
            size: 20,
            weight: 'bold',
            family: 'Arial Black',
          }
        },
        datalabels: {
          display: false,
        },
        legend: {
          // position: 'left',
          labels: {
            font: {
              size: 10,
            },
            usePointStyle: true,
          }
        },
        tooltips: false,
      },
    });
    const extraOverAddToChartData = computed(() => {
      if (props.visualiseResults) {
        const percentage = props.visualiseResults.extra_over_add_to_count / props.visualiseResults.item_count * 100;
        return {
          labels: ['EXTRA OVER / ADD TO', 'GENERAL ITEM',],
          datasets: [{
            data: [percentage, 100 - percentage],
            backgroundColor: [
              'rgba(152, 216, 56)',
              'rgb(192, 192, 192,0.2)'
            ],
            hoverOffset: 4,
            borderWidth: 1,
            cutout: '80%',
            borderRadius: 10,
          }],
        }
      }

      return {
        labels: [''],
        datasets: [
          {
            label: '',
            data: [1],
            hoverOffset: 4,
            borderWidth: 1,
            cutout: '80%',
            borderRadius: 10,
          }
        ],
      }
    })
    const extraOverAddToChartPlugins = computed(() => {
      return [
        {
          id: 'counter',
          afterDraw(chart, args, options) {
            const percentage = props.visualiseResults ? (props.visualiseResults.extra_over_add_to_count / props.visualiseResults.item_count * 100) : 0;
            const {ctx, chartArea: {top, right, bottom, left, width, height}} = chart;
            ctx.save();

            ctx.font = "50px sans-serif";
            ctx.textAlign = "center";
            ctx.textStyle = "red";
            ctx.fillText(`${percentage.toFixed(2)}%`, width / 2, top + height / 2);
            //
          },
        }
      ]
    })

    // const extraOverAddToChartOptions = ref({
    //   maintainAspectRatio: false,
    //   responsive: true,
    //   plugins: {
    //     title: {
    //       display: true,
    //       text: 'Extra Over/ Add to Items',
    //       align: 'start',
    //       color: "rgb(0,0,0)",
    //       padding: 5,
    //       font: {
    //         size: 18,
    //         weight: 'bold',
    //         family: "Arial Black"
    //         //family: 'Arial-BoldMT',
    //       }
    //     },
    //     legend: {
    //       display: false,
    //     },
    //   },
    //
    //   scales: {
    //     y: {
    //       beginAtZero: true,
    //       title: {
    //         display: false,
    //       }
    //     }
    //   }
    // });
    // const extraOverAddToChartData = computed(() => {
    //   if (props.visualiseResults) {
    //     return {
    //       labels: ['Extra Over', 'Add to',],
    //       datasets: [{
    //         data: [
    //           props.visualiseResults.extra_over_count,
    //           props.visualiseResults.add_to_count,
    //         ],
    //         backgroundColor: [
    //           'rgba(152, 216, 56)',
    //           'rgba(43, 213, 216)',
    //         ],
    //         borderColor: [
    //           'rgba(152, 216, 56)',
    //           'rgba(43, 213, 216)',
    //         ],
    //         borderWidth: 1
    //       }],
    //     }
    //   }
    //
    //   return {
    //     labels: ['Extra Over', 'Add to',],
    //     datasets: [{
    //       data: [0, 0],
    //       backgroundColor: [
    //         'rgba(152, 216, 56)',
    //         'rgba(43, 213, 216)',
    //       ],
    //       borderColor: [
    //         'rgba(152, 216, 56)',
    //         'rgba(43, 213, 216)',
    //       ],
    //       borderWidth: 1
    //     }],
    //   }
    // })

    const rateRangeChartOptions = ref({
      layout: {
        padding: 20,
      },
      scales: {
        y: {
          title: {
            display: true,
            text: 'number',
            padding: 0
          },
          ticks: {
            padding: 20,
          }
        }
      },
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: "top",
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: 'white',
          borderRadius: 12,
          font: {
            weight: 'bold',
          }
        },
        title: {
          display: true,
          text: 'Rate Ranges (no.)',
          align: 'start',
          position: "top",
          color: "rgb(0,0,0)",
          padding: 20,
          font: {
            size: 20,
            weight: 'bold',
            family: "Arial Black"
            //family: 'Arial Black',
          }
        },
        legend: {
          display: false
        }
      }
    });
    const rateRangeChartData = computed(() => {
      if (props.visualiseResults) {
        return {
          labels: [...'ABCDEFGH'].map((r) => root.$t(`rate_range.${r}`)),
          datasets: [{
            data: [...'ABCDEFGH'].map((r) => (props.visualiseResults.results_by_rate_range[r] || 0)),
            borderColor: 'rgb(76, 0, 153)',
            pointBackgroundColor: 'rgb(255,255,255)',
            pointBorderWidth: 2,
            pointRadius: 5,
            backgroundColor: 'rgb(204, 153, 255,0.5)',
          }],
        }
      }

      return {
        labels: [...'ABCDEFGH'].map((r) => root.$t(`rate_range.${r}`)),
        datasets: [{
          data: [...'ABCDEFGH'].map(() => 0),
          borderColor: 'rgb(76, 0, 153)',
          pointBackgroundColor: 'rgb(255,255,255)',
          pointBorderWidth: 2,
          pointRadius: 5,
          backgroundColor: 'rgb(204, 153, 255,0.5)',
        }],
      }
    });

    const unitChartOptions = ref({
      scales: {
        x: {
          title: {
            display: false,
          }
        }
      },
      maintainAspectRatio: false,
      responsive: true,
      indexAxis: 'y',
      plugins: {
        title: {
          display: true,
          text: 'Unit (no.)',
          align: 'start',
          padding: 20,
          color: "rgb(0,0,0)",
          font: {
            size: 20,
            weight: 'bold',
            family: "Arial Black"
          }
        },
        legend: {
          display: false
        }
      }
    });
    const unitChartData = computed(() => {
      if (props.visualiseResults) {
        return {
          labels: [...'ABCDE'].map((u) => root.$t(`unit.${u}`)),
          datasets: [{
            axis: 'y',
            label: null,
            data: [...'ABCDE'].map((u) => (props.visualiseResults.results_by_unit_id[u] || 0)),
            fill: false,
            backgroundColor: [
              'rgba(255, 99, 132)',
              'rgba(255, 159, 64)',
              'rgba(255, 205, 86)',
              'rgba(75, 192, 192)',
              'rgba(54, 162, 235)',
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)'
            ],
            borderWidth: 0.5,
            borderRadius: 10,
            borderSkipped: false,
          }]
        }
      }

      return {
        labels: [...''].map((u) => root.$t(`unit.${u}`)),
        datasets: [{
          axis: 'y',
          label: null,
          data: [0, 0, 0, 0, 0],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132)',
            'rgba(255, 159, 64)',
            'rgba(255, 205, 86)',
            'rgba(75, 192, 192)',
            'rgba(54, 162, 235)',
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)'
          ],
          borderWidth: 0.5,
          borderRadius: 10,
          borderSkipped: false,
        }]
      }
    })

    return {
      percentageLabelPlugins,
      numberLabelPlugins,

      sectionChartOptions,
      sectionChartData,

      subSectionChartOptions,
      subSectionChartData,

      specificallyOrderProprietaryChartOptions,
      specificallyOrderProprietaryChartData,

      // proprietaryChartOptions,
      // proprietaryChartData,
      // proprietaryChartPlugins,

      workNatureChartOptions,
      workNatureChartData,

      extraOverAddToChartOptions,
      extraOverAddToChartData,
      extraOverAddToChartPlugins,

      rateRangeChartOptions,
      rateRangeChartData,

      unitChartOptions,
      unitChartData,
    }
  },
}
</script>
